import { DeleteOutlined, RedoOutlined, UndoOutlined } from '@ant-design/icons';
import { AddToPhotos } from '@mui/icons-material';
import * as Sentry from '@sentry/react';
import { Button, Col, Dropdown, Modal, Popover, Progress, Row, Slider, Switch, Tooltip } from 'antd';
import MultiFileUploader from 'components/UI/admin/MultifileUploadGallery';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import DefaultAudioGenerator from "components/UI/mediaPlayers/defaultAudioGenerator";
import React, { useEffect, useRef, useState } from 'react';
import { SketchPicker } from 'react-color';
import { FileUploader } from 'react-drag-drop-files';
import { useDispatch } from 'react-redux';
import { useNonNativeEbookHighlightes } from 'store/ebookNonNativeImageHighLighter/selectors';
import { handleNonNativeEbookCreateHighlights, handleNonNativeEbookListHighlights } from 'store/ebookNonNativeImageHighLighter/thunks';
import { useCurrentUser } from 'store/users/selectors';
import styled from 'styled-components';
import COLOR from 'utils/constants/color';
import { imageUploader } from 'utils/methods/imageUploader';
import { disableBodyScroll } from 'utils/methods/math';
import { IMAGE_FILE_TYPE, UPLOAD_IMAGE_TO_FIREBASE } from "utils/constants/enum"
import { NoteMark } from 'components/UI';
const CanvasContainer = styled.canvas`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  cursor: ${({ cursorType }) => cursorType || 'default'};
`;

const StyledImage = styled.img`
  background-color: ${COLOR.white};
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  height: auto;
  width: 100%;
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  margin-bottom: 30px;
  min-height: 75vh;
`;

const ControlsContainer = styled.div`
  position: absolute;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
  flex-wrap: wrap;
  padding: 10px;
  background-color: rgba(255, 255, 255, 0.9);
  @media print {
    display: none;
  }
`;

const LineWidthPreview = styled.div`
  width: 100px;
  height: ${({ strokeWidth }) => strokeWidth}px;
  background-color: ${({ color }) => (color ? color : 'black')};
  margin-top: ${({ top }) => top}px;
`;
const FileUploadArea = styled.div`
    height: 100%;
    border: 1px dashed gray;
    padding: 5px 12px;
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

const Column = styled(Col)`
    display: flex;
    justify-content: center;
    align-items: center;
}
`;
const Text = styled.div`
    font-size: 12px;
`;

const ImageHighlighterAdmin = ({ imageUrl, pageId, bookId, setImageConfiguration, path, onLoading, onChange, setpagePoster,isNonNative = false, imageConfiguration={} }) => {
    const showAlert = useAlert();
    const canvasRef = useRef(null);
    const imageRef = useRef(null);
    const currentUser = useCurrentUser();
    const [rectangles, setRectangles] = useState([]);
    const [newRect, setNewRect] = useState(null);
    const [isDrawing, setIsDrawing] = useState(false);
    const [selectedColor, setSelectedColor] = useState('#50e3c2');
    const [strokeWidth, setStrokeWidth] = useState(2);
    const [opacity, setOpacity] = useState(0.5);
    const [naturalDimensions, setNaturalDimensions] = useState({ width: 1, height: 1 });
    const [isHighlighterMode, setIsHighlighterMode] = useState(false);
    const [isAnnotationsVisible, setIsAnnotationsVisible] = useState(false);
    const [history, setHistory] = useState([]);
    const [redoHistory, setRedoHistory] = useState([]);
    const [hoveredRectIndex, setHoveredRectIndex] = useState(null);
    const dispatch = useDispatch();
    const ebook_highlights = useNonNativeEbookHighlightes();
    const [highlights, setHighlights] = useState({});
    const [is_image_loaded, setIsImageLoaded] = useState(false);
    const [loadingMap, setLoadingMap] = useState(0)
    const [loader, setLoader] = useState(false);
    const [audioUrl, setAudioUrl] = useState('');
    const [rectangleIndex, setRectangleIndex] = useState({});
    const [videoUrl, setVideoUrl] = useState('');
    const [openAllModal, setAllModal] = useState(false);
    const [openAudioModal, setAudioModal] = useState(false);
    const [openVideoModal, setVideoModal] = useState(false);
    const [openDefinitionModal, setDefinitionModal] = useState(false);
    const [resultRectangle, setResultRectange] = useState('');
    const [isPointer,setIsPointer] = useState(false);
    const [isMoving, setIsMoving] = useState(false);
    const [movingRectIndex, setMovingRectIndex] = useState(null);
    const [moveStartPos, setMoveStartPos] = useState(null);
    const [isResizing, setIsResizing] = useState(false);
    const [resizingRectIndex, setResizingRectIndex] = useState(null);
    const [resizeStartPos, setResizeStartPos] = useState(null);
    const [isMoveMode, setIsMoveMode] = useState(localStorage.getItem('isMoveMode') === 'true');
    const [isResizeMode, setIsResizeMode] = useState(localStorage.getItem('isResizeMode') === 'true');
    const [isOverRectangle, setIsOverRectangle] = useState(false);
    const [isLoadingImage, setIsLoadingImage] = useState(true);

    useEffect(() => {
        if (bookId && currentUser?.id) {
            dispatch(handleNonNativeEbookListHighlights(bookId));
        }
    }, [bookId]);
    useEffect(() => {
        setIsLoadingImage(true);
    }, [imageUrl]);

    useEffect(() => {
        const fetchData = async () => {
            if (bookId && pageId && ebook_highlights) {
                if (Array.isArray(ebook_highlights) && ebook_highlights.length > 0 && ebook_highlights[0].book_id === bookId) {
                    const page_item = ebook_highlights.find(h => parseInt(h.page_id) === parseInt(pageId));
                    if (page_item) {
                        if (highlights && highlights.page_id === page_item.page_id && highlights.book_id === page_item.book_id) {
                            return;
                        }
                        setHighlights(page_item);
                        setIsAnnotationsVisible(page_item?.show);
                        if (Array.isArray(page_item.data.rectangles)) {
                            page_item.data.rectangles.forEach(rect => {
                                rect.isHighlighterMode = false;
                            });
                            setRectangles(page_item.data.rectangles);
                            setNaturalDimensions(page_item.data.naturalDimensions);
                        } else {
                            setRectangles([]);
                            setHighlights({
                                page_id: pageId,
                                book_id: bookId,
                                data: {
                                    rectangles: [],
                                    naturalDimensions: { width: 1, height: 1 },
                                },
                            });
                        }
                    } else {
                        setRectangles([]);
                        setHighlights({
                            page_id: pageId,
                            book_id: bookId,
                            data: {
                                rectangles: [],
                                naturalDimensions: { width: 1, height: 1 },
                            },
                        });
                        const canvas = canvasRef.current;
                        const image = imageRef.current;
                        if (canvas && image) {
                            setNaturalDimensions({
                                width: image.naturalWidth,
                                height: image.naturalHeight,
                            });
                        }
                    }
                }
            }
        };

        fetchData();
    }, [ebook_highlights, pageId, bookId]);


    useEffect(() => {
        const handleResize = () => {
            const canvas = canvasRef.current;
            const image = imageRef.current;
            if (canvas && image && image.naturalWidth && image.naturalHeight) {
                canvas.width = image.clientWidth;
                canvas.height = image.clientHeight;
                setImageConfiguration({
                    width: image.naturalWidth,
                    height: image.naturalHeight,
                    clientWidth: image.clientWidth,
                    clientHeight: image.clientHeight,
                });
                redrawCanvas();
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => window.removeEventListener('resize', handleResize);
    }, [rectangles, isAnnotationsVisible, isLoadingImage, imageUrl]);


    const getRelativePosition = (event) => {
        const canvas = canvasRef.current;
        const rect = canvas.getBoundingClientRect();
        return {
            x: ((event.clientX - rect.left) / rect.width) * naturalDimensions.width,
            y: ((event.clientY - rect.top) / rect.height) * naturalDimensions.height,
        };
    };

    const getTouchRelativePosition = (touch) => {
        const canvas = canvasRef.current;
        const rect = canvas.getBoundingClientRect();
        return {
            x: ((touch.clientX - rect.left) / rect.width) * naturalDimensions.width,
            y: ((touch.clientY - rect.top) / rect.height) * naturalDimensions.height,
        };
    };

    const disableScroll = () => {
        if (window.innerWidth < 800) {
            // document.body.style.overflow = 'hidden';
            disableBodyScroll("ImageHighlighterAdmin")
        }
    };

    const enableScroll = () => {
        if (window.innerWidth < 800) {
            document.body.style.overflow = 'auto';
        }
    };


    const checkOverlap = (rect1, existingRectangles) => {
        const MARGIN = 2;
        
        // For a new rectangle being drawn
        // First normalize the coordinates for the new rectangle
        const normalizedRect1 = {
            x: rect1.width < 0 ? rect1.x + rect1.width : rect1.x,
            y: rect1.height < 0 ? rect1.y + rect1.height : rect1.y,
            width: Math.abs(rect1.width),
            height: Math.abs(rect1.height)
        };
    
        // Now create boundaries with margin
        const r1 = {
            left: normalizedRect1.x - MARGIN,
            right: normalizedRect1.x + normalizedRect1.width + MARGIN,
            top: normalizedRect1.y - MARGIN,
            bottom: normalizedRect1.y + normalizedRect1.height + MARGIN
        };
    
        return existingRectangles.some(rect2 => {
            // Normalize coordinates for existing rectangle
            const normalizedRect2 = {
                x: rect2.width < 0 ? rect2.x + rect2.width : rect2.x,
                y: rect2.height < 0 ? rect2.y + rect2.height : rect2.y,
                width: Math.abs(rect2.width),
                height: Math.abs(rect2.height)
            };
    
            // Create boundaries with margin for existing rectangle
            const r2 = {
                left: normalizedRect2.x - MARGIN,
                right: normalizedRect2.x + normalizedRect2.width + MARGIN,
                top: normalizedRect2.y - MARGIN,
                bottom: normalizedRect2.y + normalizedRect2.height + MARGIN
            };
    
            // Check if rectangles overlap with margin
            return !(r2.left > r1.right || 
                    r2.right < r1.left || 
                    r2.top > r1.bottom ||
                    r2.bottom < r1.top);
        });
    };
    
    
    const clampRectToImageBounds = (rect) => {
        const maxW = naturalDimensions.width;
        const maxH = naturalDimensions.height;
        const minX = Math.min(rect.x, rect.x + rect.width);
        const minY = Math.min(rect.y, rect.y + rect.height);
        let normW = Math.abs(rect.width);
        let normH = Math.abs(rect.height);
        normW = Math.min(normW, maxW);
        normH = Math.min(normH, maxH);
        let clampedMinX = Math.max(0, Math.min(minX, maxW - normW));
        let clampedMinY = Math.max(0, Math.min(minY, maxH - normH));
        normW = Math.min(normW, maxW - clampedMinX);
        normH = Math.min(normH, maxH - clampedMinY);
        const newX = rect.width >= 0 ? clampedMinX : clampedMinX + normW;
        const newY = rect.height >= 0 ? clampedMinY : clampedMinY + normH;
        const newW = rect.width >= 0 ? normW : -normW;
        const newH = rect.height >= 0 ? normH : -normH;
        return { ...rect, x: newX, y: newY, width: newW, height: newH };
    };

    const handleMouseDown = (e) => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        
        const { x, y } = getRelativePosition(e);

        if (isMoveMode || isResizeMode) {
            for (let i = 0; i < rectangles.length; i++) {
                const rectangle = rectangles[i];
                const normalizedX = Math.min(rectangle.x, rectangle.x + rectangle.width);
                const normalizedY = Math.min(rectangle.y, rectangle.y + rectangle.height);
                const normalizedWidth = Math.abs(rectangle.width);
                const normalizedHeight = Math.abs(rectangle.height);
                
                if (x >= normalizedX && x <= normalizedX + normalizedWidth &&
                    y >= normalizedY && y <= normalizedY + normalizedHeight) {
                    if (isMoveMode) {
                        setHistory((prev) => [...prev, rectangles]);
                        setIsMoving(true);
                        setMovingRectIndex(i);
                        setMoveStartPos({ x, y });
                        disableScroll();
                        return;
                    }
                    if (isResizeMode) {
                        setHistory((prev) => [...prev, rectangles]);
                        setIsResizing(true);
                        setResizingRectIndex(i);
                        setResizeStartPos({ x, y });
                        disableScroll();
                        return;
                    }
                }
            }
            return;
        }

        if (hoveredRectIndex !== null) return;
        setIsDrawing(true);
        disableScroll();
        setNewRect({ x, y, width: 0, height: 0, color: selectedColor, strokeWidth, isHighlighterMode, opacity, non_native: isNonNative ? true : false });
    };

    const handleMouseMove = (e) => {
        const { x, y } = getRelativePosition(e);
        if (isMoving && movingRectIndex !== null && moveStartPos) {
            const deltaX = x - moveStartPos.x;
            const deltaY = y - moveStartPos.y;
            
            const updatedRectangles = [...rectangles];
            const movingRect = updatedRectangles[movingRectIndex];
            
            const newRectPosition = {
                ...movingRect,
                x: movingRect.x + deltaX,
                y: movingRect.y + deltaY
            };
            
            const clampedPosition = clampRectToImageBounds(newRectPosition);
            const otherRectangles = updatedRectangles.filter((_, i) => i !== movingRectIndex);
            if (!checkOverlap(clampedPosition, otherRectangles)) {
                updatedRectangles[movingRectIndex] = clampedPosition;
                setRectangles(updatedRectangles);
                setMoveStartPos({ x, y });
            }
        } else if (isResizing && resizingRectIndex !== null && resizeStartPos) {
            const deltaX = x - resizeStartPos.x;
            const deltaY = y - resizeStartPos.y;
            
            const updatedRectangles = [...rectangles];
            const resizingRect = updatedRectangles[resizingRectIndex];
            
            const newRectSize = {
                ...resizingRect,
                width: resizingRect.width + deltaX,
                height: resizingRect.height + deltaY
            };
            
            if (Math.abs(newRectSize.width) > 20 && Math.abs(newRectSize.height) > 20) {
                const otherRectangles = updatedRectangles.filter((_, i) => i !== resizingRectIndex);
                const clampedSize = clampRectToImageBounds(newRectSize);
                if (!checkOverlap(clampedSize, otherRectangles)) {
                    updatedRectangles[resizingRectIndex] = clampedSize;
                    setRectangles(updatedRectangles);
                    setResizeStartPos({ x, y });
                }
            }
        } else if (isDrawing) {
            const updatedRect = {
                ...newRect,
                width: x - newRect.x,
                height: y - newRect.y
            };
            if (!checkOverlap(updatedRect, rectangles)) {
                setNewRect((prevRect) => ({
                    ...prevRect,
                    width: x - prevRect.x,
                    height: y - prevRect.y,
                }));
            }   
        } else {
           const hoveredIndex = rectangles.findIndex((rect) => {
            const normalizedX = Math.min(rect.x, rect.x + rect.width);
            const normalizedY = Math.min(rect.y, rect.y + rect.height);
            const normalizedWidth = Math.abs(rect.width);
            const normalizedHeight = Math.abs(rect.height);
            
            return x >= normalizedX &&
                   x <= normalizedX + normalizedWidth &&
                   y >= normalizedY &&
                   y <= normalizedY + normalizedHeight;
        });
        
        const isHovering = hoveredIndex !== -1;
        setIsOverRectangle(isHovering);
        setIsPointer(isHovering && !isMoveMode && !isResizeMode);
        setHoveredRectIndex(isHovering ? hoveredIndex : null);
        }
    };

    const handleMouseUp = () => {
        if (isMoving) {
            enableScroll();
            saveRectanglesToDB(rectangles);
            setIsMoving(false);
            setMovingRectIndex(null);
            setMoveStartPos(null);
        } else if (isResizing) {
            enableScroll();
            saveRectanglesToDB(rectangles);
            setIsResizing(false);
            setResizingRectIndex(null);
            setResizeStartPos(null);
        } else if (isDrawing) {
            enableScroll();
            if (newRect.width !== 0 && newRect.height !== 0) {
                const absWidth = Math.abs(newRect.width);
                const absHeight = Math.abs(newRect.height);
                if (absWidth >= 20 && absHeight >= 20) {
                    const updatedRectangles = [...rectangles, newRect];
                    setHistory([...history, rectangles]);
                    setRectangles(updatedRectangles);
                    saveRectanglesToDB(updatedRectangles);
                }
            }
            setNewRect(null);
            setIsDrawing(false);
            setRedoHistory([]);
        }
    };

    const handleTouchStart = (e) => {
        const canvas = canvasRef.current;
        if (!canvas) return;
        
        const { x, y } = getTouchRelativePosition(e.touches[0]);

        if (isMoveMode || isResizeMode) {
            for (let i = 0; i < rectangles.length; i++) {
                const rectangle = rectangles[i];
                const normalizedX = Math.min(rectangle.x, rectangle.x + rectangle.width);
                const normalizedY = Math.min(rectangle.y, rectangle.y + rectangle.height);
                const normalizedWidth = Math.abs(rectangle.width);
                const normalizedHeight = Math.abs(rectangle.height);
                
                if (x >= normalizedX && x <= normalizedX + normalizedWidth &&
                    y >= normalizedY && y <= normalizedY + normalizedHeight) {
                    if (isMoveMode) {
                        setHistory((prev) => [...prev, rectangles]);
                        setIsMoving(true);
                        setMovingRectIndex(i);
                        setMoveStartPos({ x, y });
                        disableScroll();
                        return;
                    }
                    if (isResizeMode) {
                        setHistory((prev) => [...prev, rectangles]);
                        setIsResizing(true);
                        setResizingRectIndex(i);
                        setResizeStartPos({ x, y });
                        disableScroll();
                        return;
                    }
                }
            }
            return;
        }

        if (hoveredRectIndex !== null) return;
        setIsDrawing(true);
        disableScroll();
        setNewRect({ x, y, width: 0, height: 0, color: selectedColor, strokeWidth, isHighlighterMode, opacity,non_native: isNonNative ? true :false });
    };

    const handleTouchMove = (e) => {
        const { x, y } = getTouchRelativePosition(e.touches[0]);
        if (isMoving && movingRectIndex !== null && moveStartPos) {
            const deltaX = x - moveStartPos.x;
            const deltaY = y - moveStartPos.y;
            
            const updatedRectangles = [...rectangles];
            const movingRect = updatedRectangles[movingRectIndex];
            
            const newRectPosition = {
                ...movingRect,
                x: movingRect.x + deltaX,
                y: movingRect.y + deltaY
            };
            
            const clampedPosition = clampRectToImageBounds(newRectPosition);
            const otherRectangles = updatedRectangles.filter((_, i) => i !== movingRectIndex);
            if (!checkOverlap(clampedPosition, otherRectangles)) {
                updatedRectangles[movingRectIndex] = clampedPosition;
                setRectangles(updatedRectangles);
                setMoveStartPos({ x, y });
            }
        } else if (isResizing && resizingRectIndex !== null && resizeStartPos) {
            const deltaX = x - resizeStartPos.x;
            const deltaY = y - resizeStartPos.y;
            
            const updatedRectangles = [...rectangles];
            const resizingRect = updatedRectangles[resizingRectIndex];
            
            const newRectSize = {
                ...resizingRect,
                width: resizingRect.width + deltaX,
                height: resizingRect.height + deltaY
            };
            
            if (Math.abs(newRectSize.width) > 20 && Math.abs(newRectSize.height) > 20) {
                const otherRectangles = updatedRectangles.filter((_, i) => i !== resizingRectIndex);
                const clampedSize = clampRectToImageBounds(newRectSize);
                if (!checkOverlap(clampedSize, otherRectangles)) {
                    updatedRectangles[resizingRectIndex] = clampedSize;
                    setRectangles(updatedRectangles);
                    setResizeStartPos({ x, y });
                }
            }
        } else if (isDrawing && newRect) {
            const updatedRect = {
                ...newRect,
                width: x - newRect.x,
                height: y - newRect.y
            };

            if (!checkOverlap(updatedRect, rectangles)) {
                setNewRect((prevRect) => ({
                    ...prevRect,
                    width: x - prevRect.x,
                    height: y - prevRect.y,
                }));
            }   
        } else {
            const hoveredIndex = rectangles.findIndex(
                (rect) =>
                    x >= rect.x &&
                    x <= rect.x + rect.width &&
                    y >= rect.y &&
                    y <= rect.y + rect.height
            );
            setHoveredRectIndex(hoveredIndex !== -1 ? hoveredIndex : null);
        }
    };

    const handleTouchEnd = () => {
        if (isMoving) {
            enableScroll();
            saveRectanglesToDB(rectangles);
            setIsMoving(false);
            setMovingRectIndex(null);
            setMoveStartPos(null);
        } else if (isResizing) {
            enableScroll();
            saveRectanglesToDB(rectangles);
            setIsResizing(false);
            setResizingRectIndex(null);
            setResizeStartPos(null);
        } else if (isDrawing) {
            enableScroll();
            if (newRect.width !== 0 && newRect.height !== 0) {
                const absWidth = Math.abs(newRect.width);
                const absHeight = Math.abs(newRect.height);
                if (absWidth >= 20 && absHeight >= 20) {
                    const updatedRectangles = [...rectangles, newRect];
                    setHistory([...history, rectangles]);
                    setRectangles(updatedRectangles);
                    saveRectanglesToDB(updatedRectangles);
                }
            }
            setNewRect(null);
            setIsDrawing(false);
            setRedoHistory([]);
        }
    };

    const handleColorChange = (color) => {
        setSelectedColor(color.hex);
        localStorage.setItem('selectedColor', color.hex);
    };

    const handleStrokeWidthChange = ({ key }) => {
        setStrokeWidth(Number(key));
        localStorage.setItem('strokeWidth', key);
    };

    const handleOpacityChange = (value) => {
        setOpacity(value / 100);
        localStorage.setItem('opacity', value / 100);
    };

    const handleModeChange = (checked) => {
        setIsHighlighterMode(checked);
        localStorage.setItem('isHighlighterMode', checked);
    };

    const handleMoveModeChange = (checked) => {
        setIsMoveMode(checked);
        localStorage.setItem('isMoveMode', checked);
        if (checked) {
            setIsResizeMode(false);
            localStorage.setItem('isResizeMode', false);
        }
    };

    const handleResizeModeChange = (checked) => {
        setIsResizeMode(checked);
        localStorage.setItem('isResizeMode', checked);
        if (checked) {
            setIsMoveMode(false);
            localStorage.setItem('isMoveMode', false);
        }
    };


    const handleUndo = () => {
        if (history.length > 0) {
            const previousState = history[history.length - 1];
            setRedoHistory((prev) => [rectangles, ...prev]);
            setRectangles(previousState);
            saveRectanglesToDB(previousState);
            setHistory((prev) => prev.slice(0, -1));
        }
    };

    const handleRedo = () => {
        if (redoHistory.length > 0) {
            const nextState = redoHistory[0];
            setHistory((prev) => [...prev, rectangles]);
            setRectangles(nextState);
            saveRectanglesToDB(nextState);
            setRedoHistory((prev) => prev.slice(1));
        }
    };

    const handleDelete = (index) => {
        if (isMoveMode || isResizeMode) return;
        Modal.confirm({
            title: 'Delete Canvas',
            content: 'Are you sure you want to delete this Canvas?',
            okText: 'Yes, Delete',
            okType: 'danger',
            cancelText: 'Cancel',
            onOk: () => {
                const updatedRectangles = rectangles.filter((_, i) => i !== index);
                setHistory([...history, rectangles]);
                setRectangles(updatedRectangles);
                saveRectanglesToDB(updatedRectangles);
            }
        });
    };

    const handleClearAll = () => {
        Modal.confirm({
            title: 'Clear All Highlights',
            content: 'Are you sure you want to clear all highlights? This action cannot be undone.',
            okText: 'Yes, Clear All',
            okType: 'danger',
            cancelText: 'Cancel',
            onOk: () => {
                setHistory([...history, rectangles]);
                setRectangles([]);
                saveRectanglesToDB([]);
            }
        });
    };

    const saveRectanglesToDB = async (rectangles, show = true) => {
        try {
            let data = {
                rectangles,
                naturalDimensions
            };
            const dt = {
                user_id: currentUser.id,
                page_id: pageId,
                book_id: bookId,
                data,
                show: show,
                non_native: true,
            };
            await dispatch(handleNonNativeEbookCreateHighlights(dt));
        } catch (error) {
            showAlert('Failed to save', "error");
            Sentry.captureException(`378 Error during saveRectanglesToDB: ${error}`);
        }
    };

    const redrawCanvas = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        if (isAnnotationsVisible) {
            rectangles.forEach((rect, index) => {
                // First draw the highlight rectangle
                if (rect.isHighlighterMode) {
                    ctx.fillStyle = `${rect.color}${Math.floor(rect.opacity * 255).toString(16)}`;
                    ctx.fillRect(
                        (rect.x / naturalDimensions.width) * canvas.width,
                        (rect.y / naturalDimensions.height) * canvas.height,
                        (rect.width / naturalDimensions.width) * canvas.width,
                        (rect.height / naturalDimensions.height) * canvas.height
                    );
                } else {
                    if (isMoveMode) {
                        ctx.strokeStyle = '#1890ff';
                        ctx.lineWidth = 3;
                        ctx.setLineDash([5, 5]);
                    } else if (isResizeMode) {
                        ctx.strokeStyle = '#52c41a';
                        ctx.lineWidth = 3;
                        ctx.setLineDash([10, 5]);
                    } else {
                        ctx.strokeStyle = rect.color;
                        ctx.lineWidth = rect.strokeWidth;
                        ctx.setLineDash([]);
                    }
                    ctx.strokeRect(
                        (rect.x / naturalDimensions.width) * canvas.width,
                        (rect.y / naturalDimensions.height) * canvas.height,
                        (rect.width / naturalDimensions.width) * canvas.width,
                        (rect.height / naturalDimensions.height) * canvas.height
                    );
                    ctx.setLineDash([]);
                }
            
                // Calculate the actual rectangle boundaries
                const rectX = (rect.x / naturalDimensions.width) * canvas.width;
                const rectY = (rect.y / naturalDimensions.height) * canvas.height;
                const rectWidth = (rect.width / naturalDimensions.width) * canvas.width;
                const rectHeight = (rect.height / naturalDimensions.height) * canvas.height;
            
                // Normalize coordinates for buttons
                const normalizedX = Math.min(rectX, rectX + rectWidth);
                const normalizedY = Math.min(rectY, rectY + rectHeight);
                const normalizedMaxX = Math.max(rectX, rectX + rectWidth);
            
                // Draw Upload button - positioned at top-left
                const uploadSize = 60;
                const uploadHeight = 25;
                ctx.fillStyle = 'teal';
                ctx.fillRect(normalizedX, normalizedY, uploadSize, uploadHeight);
                ctx.fillStyle = 'white';
                ctx.font = '14px Arial';
                ctx.fillText('Media', normalizedX + 6, normalizedY + 17);
            
                // Store upload button coordinates
                rect.audioButton = {
                    x: normalizedX,
                    y: normalizedY,
                    width: uploadSize,
                    height: uploadHeight
                };
            
                if (!isMoveMode && !isResizeMode) {
                    // Draw Close (X) button - positioned at top-right
                    const crossSize = 12;
                    const rectX1 = Math.min(rect.x, rect.x + rect.width);
                    const rectY1 = Math.min(rect.y, rect.y + rect.height);
                    const crossX = (rectX1 / naturalDimensions.width) * canvas.width;
                    const crossY = (rectY1 / naturalDimensions.height) * canvas.height;
                    ctx.fillStyle = 'red';
                    ctx.fillRect(crossX, crossY, crossSize, crossSize);
                    ctx.fillStyle = 'white';
                    ctx.font = '10px Arial';
                    ctx.fillText('X', crossX + crossSize / 4, crossY + (crossSize * 3) / 4);
            
                    // Store close button coordinates
                    rect.crossButton = {
                        x: crossX,
                        y: crossY,
                        width: crossSize,
                        height: crossSize
                    };
                } else {
                    delete rect.crossButton;
                }
            
            })
        }

        if (newRect) {
            if (newRect.isHighlighterMode) {
                ctx.fillStyle = `${newRect.color}${Math.floor(newRect.opacity * 255).toString(16)}`; // Set fill color with opacity
                ctx.fillRect(
                    (newRect.x / naturalDimensions.width) * canvas.width,
                    (newRect.y / naturalDimensions.height) * canvas.height,
                    (newRect.width / naturalDimensions.width) * canvas.width,
                    (newRect.height / naturalDimensions.height) * canvas.height
                );
            } else {
                ctx.strokeStyle = newRect.color;
                ctx.lineWidth = newRect.strokeWidth;
                ctx.strokeRect(
                    (newRect.x / naturalDimensions.width) * canvas.width,
                    (newRect.y / naturalDimensions.height) * canvas.height,
                    (newRect.width / naturalDimensions.width) * canvas.width,
                    (newRect.height / naturalDimensions.height) * canvas.height
                );
            }
        }
    };

    useEffect(() => {
        redrawCanvas();
    }, [rectangles, newRect, isAnnotationsVisible, hoveredRectIndex, isMoveMode, isResizeMode]);

    const strokeWidthMenu = {
        items: [2, 3, 4, 5, 6, 7, 8].map((width) => ({
            key: width,
            label: <LineWidthPreview strokeWidth={width} top={5} color="black" />,
            onClick: () => handleStrokeWidthChange({ key: width })
        }))
    };

    const handleMouseLeave = () => {
        setHoveredRectIndex(null);
        setIsOverRectangle(false);
    };
    const onSelectImage = (v, index) => {
        onChange({ url: v, pageId: index });
        setpagePoster(v)
    }
    const handleChange = (file) => {
        setHistory([...history, rectangles]);
        // setRectangles([]);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        // saveRectanglesToDB([]);
        uploadToStorage(file, pageId)
        reader.onloadend = function (e) {
            let v = reader.result;
            setpagePoster(v)
            //onChange({url:v, pageId})
        };
    };

    const callLoader = (val) => {
        setLoader(val);
        if (onLoading) {
            onLoading(val)
        }
    }
      const uploadToStorage = async (file, index) => {
            if (file) {
                try {
                    const onUpdatePer = (per) => {
                        setLoadingMap(per);
                        callLoader(true);
                    };
                    const download_url = await imageUploader(file, onUpdatePer,UPLOAD_IMAGE_TO_FIREBASE)
                    if (download_url) {
                        onChange({ url: download_url, pageId: index });
                    } else {
                        showAlert("Unable to upload image.", "error");
                    }
                } catch (error) {
                    console.error("Upload error:", error);
                    Sentry.captureException(`379 Error during uploadToStorage: ${error}`);
                    showAlert("Unable to upload image.", "error");
                } finally {
                    callLoader(false);
                    setLoadingMap(0);
                }
            } else {
                console.log("No file to upload.");
            }
        };
    
    const getEventCoordinates = (e) => {
        if (e.type === 'touchstart' || e.type === 'touchend') {
            const touch = e.changedTouches[0];
            return {
                clientX: touch.clientX,
                clientY: touch.clientY
            };
        }
        return {
            clientX: e.clientX,
            clientY: e.clientY
        };
    };
    
    const calculateCanvasCoordinates = (clientX, clientY, canvas) => {
        const rect = canvas.getBoundingClientRect();
        const mouseX = clientX - rect.left;
        const mouseY = clientY - rect.top;
    
        // Account for canvas scaling
        const scaleX = canvas.width / canvas.clientWidth;
        const scaleY = canvas.height / canvas.clientHeight;
    
        return {
            scaledX: mouseX * scaleX,
            scaledY: mouseY * scaleY,
            mouseX,  // Keep original coordinates for rectangle detection
            mouseY
        };
    };
    
    const isClickInside = (x, y, button) => {
        if (!button) return false;
        return x >= button.x &&
               x <= button.x + button.width &&
               y >= button.y &&
               y <= button.y + button.height;
    };
    
    const handleCanvasClick = (e) => {
      e.preventDefault(); // Prevent any default behavior

      const canvas = canvasRef.current;
      if (!canvas) return;

      const { clientX, clientY } = getEventCoordinates(e);
      const { scaledX, scaledY, mouseX, mouseY } = calculateCanvasCoordinates(
        clientX,
        clientY,
        canvas
      );

      if (isMoveMode || isResizeMode) {
        return;
      }

      for (let i = 0; i < rectangles.length; i++) {
        const rectangle = rectangles[i];

        // Check for close button click
        if (isClickInside(mouseX, mouseY, rectangle.crossButton)) {
          handleDelete(i);
          return;
        }

        // Check for upload button click
        if (isClickInside(mouseX, mouseY, rectangle.audioButton)) {
          setAllModal(true);
          setRectangleIndex(i);
          setAudioUrl(rectangle.audioFile || "");
          setVideoUrl(rectangle.videoFile || "");
          setResultRectange(rectangle);
          return;
        }

        // Calculate normalized rectangle coordinates
        const rectX = (rectangle.x / naturalDimensions.width) * canvas.width;
        const rectY = (rectangle.y / naturalDimensions.height) * canvas.height;
        const rectWidth =
          (rectangle.width / naturalDimensions.width) * canvas.width;
        const rectHeight =
          (rectangle.height / naturalDimensions.height) * canvas.height;

        // Normalize rectangle boundaries
        const normalizedX = Math.min(rectX, rectX + rectWidth);
        const normalizedY = Math.min(rectY, rectY + rectHeight);
        const normalizedWidth = Math.abs(rectWidth);
        const normalizedHeight = Math.abs(rectHeight);

        if (
          mouseX >= normalizedX &&
          mouseX <= normalizedX + normalizedWidth &&
          mouseY >= normalizedY &&
          mouseY <= normalizedY + normalizedHeight &&
          isPointer
        ) {
          const isButtonArea =
            isClickInside(mouseX, mouseY, rectangle.crossButton) ||
            isClickInside(mouseX, mouseY, rectangle.audioButton);

          if (!isButtonArea) {
            setAllModal(true);
            setRectangleIndex(i);
            setAudioUrl(rectangle.audioFile || "");
            setVideoUrl(rectangle.videoFile || "");
            setResultRectange(rectangle);
            return;
          }
        }
      }
    };


    const normalizeRectangleCoords = (rect) => {
        return {
            x: Math.min(rect.x, rect.x + rect.width),
            y: Math.min(rect.y, rect.y + rect.height),
            width: Math.abs(rect.width),
            height: Math.abs(rect.height)
        };
    };

    const handleUpdateAudio = (data) => {
        const updatedRectangles = rectangles || [];
        if (updatedRectangles[rectangleIndex]) {
            updatedRectangles[rectangleIndex].audioFile = data;
            updatedRectangles[rectangleIndex].videoFile = '';
            updatedRectangles[rectangleIndex].definition = '';
        }
        saveRectanglesToDB(updatedRectangles);
        setAudioUrl(data);
        setVideoUrl('');
        setResultRectange((prev) =>
            typeof prev === 'object' && prev !== null ? { ...prev, audioFile: data, videoFile: '', definition: '' } : prev,
        );
    }
    
    const handleUpdateVideo = (data) => {
        const updatedRectangles = rectangles || [];
        if (updatedRectangles[rectangleIndex]) {
            updatedRectangles[rectangleIndex].videoFile = data;
            updatedRectangles[rectangleIndex].audioFile = '';
            updatedRectangles[rectangleIndex].definition = '';
        }
        saveRectanglesToDB(updatedRectangles);
        setVideoUrl(data);
        setAudioUrl('');
        setResultRectange((prev) =>
            typeof prev === 'object' && prev !== null ? { ...prev, videoFile: data, audioFile: '', definition: '' } : prev,
        );
    }

    const handleUpdateDefinition = (data, word) => {
        const updatedRectangles = rectangles || [];
        if (updatedRectangles[rectangleIndex]) {
            updatedRectangles[rectangleIndex].definition = data || '';
            updatedRectangles[rectangleIndex].word = word || '';
            updatedRectangles[rectangleIndex].audioFile = '';
            updatedRectangles[rectangleIndex].videoFile = '';
        }
        saveRectanglesToDB(updatedRectangles);
        setAudioUrl('');
        setVideoUrl('');
        setResultRectange((prev) =>
            typeof prev === 'object' && prev !== null
                ? { ...prev, definition: data || '', word: word || '', audioFile: '', videoFile: '' }
                : prev,
        );
    }

    const handleClose = () => {
        setVideoModal(false);
        setAudioModal(false);
        // setAllModal(false);
        setDefinitionModal(false);
    }

    const handleCloseModal = () => {
        setAllModal(false);
    }


    const handleMouseOutForCanvas = () => {
        if(isDrawing){
            setNewRect(null);
            setIsDrawing(false);
            enableScroll();
        }
        if(isMoving){
            setIsMoving(false);
            setMovingRectIndex(null);
            setMoveStartPos(null);
            enableScroll();
        }
        if(isResizing){
            setIsResizing(false);
            setResizingRectIndex(null);
            setResizeStartPos(null);
            enableScroll();
        }
        setIsOverRectangle(false);
    }

    return (
        <>
        <MultiFileUploader inModal  onSelect={v=>{ onSelectImage(v, pageId) }}/>
            <div className='flex items-center gap-10px mb-10px'>Resolution: {imageConfiguration.clientWidth} * {imageConfiguration.clientHeight}
            <NoteMark note=":- Changing the image resolution may affect the accuracy of highlight positioning." />
            </div>
         <FileUploader
                classes={`file-uploader  ${isNonNative ? "non-native-file-uploader" :""}`}
                handleChange={handleChange}
                name="file"
                types={IMAGE_FILE_TYPE}
            >
                <FileUploadArea>
                    {loader && <Progress type="line" percent={loadingMap} size={"small"} className={"fileProgress"} showInfo={false} />}
                    <Row className="box box-1">
                        <Column span={2}>
                            <AddToPhotos color="primary" />
                        </Column>
                        <Column span={17}>
                            <Text>
                                Upload or drop a file right here
                            </Text>
                        </Column>
                        <Column span={4}>
                            <Text>
                                {IMAGE_FILE_TYPE.join(",")}
                            </Text>
                        </Column>
                    </Row>
                </FileUploadArea>
            </FileUploader>
            <Container className="container to_be_print"> 
           <StyledImage
               ref={imageRef}
               src={imageUrl}
               alt="To be highlighted"
               className="image to_be_print"
               onError={() => {
                   setIsLoadingImage(false);
               }}
               onLoadStart={() => {
                   setIsLoadingImage(true);
               }}
               onLoadEnd={() => {
                   setIsLoadingImage(false);
               }}
               onLoad={() => {
                   setTimeout(() => {
                       const canvas = canvasRef.current;
                       const image = imageRef.current;
                       if (canvas && image && image.naturalWidth && image.naturalHeight) {
                           setImageConfiguration({
                               width: image.naturalWidth,
                               height: image.naturalHeight,
                               clientWidth: image.clientWidth,
                               clientHeight: image.clientHeight,
                           });
                           setNaturalDimensions({
                               width: image.naturalWidth,
                               height: image.naturalHeight,
                           });
                           canvas.width = image.clientWidth;
                           canvas.height = image.clientHeight;
                           setIsImageLoaded(true);
                           setIsLoadingImage(false);
                           redrawCanvas();
                       }
                   }, 50);
               }}
           />
           
           <CanvasContainer
               ref={canvasRef}
               cursorType={
                   isMoveMode && isOverRectangle ? 'move' : 
                   isResizeMode && isOverRectangle ? 'nwse-resize' : 
                   (isMoveMode || isResizeMode) ? 'cursor-pointer' :
                   isPointer ? 'pointer' : 
                   'crosshair'
               }
               className="highlight-canvas"
               onMouseOut={handleMouseOutForCanvas}
               onMouseDown={handleMouseDown}
               onMouseMove={handleMouseMove}
               onMouseUp={handleMouseUp}
               onClick={handleCanvasClick}
               onTouchStart={handleTouchStart}
               onTouchMove={handleTouchMove}
               onTouchEnd={handleTouchEnd}
               onMouseLeave={handleMouseLeave}
           />
           {is_image_loaded &&!isLoadingImage ? (
               <ControlsContainer>
                   <Popover
                       content={<SketchPicker color={selectedColor} onChange={handleColorChange} />}
                       title="Select Color"
                       trigger="click"
                   >
                       <Button style={{ width: 50, height: 20, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 0 }}>
                           <div style={{ backgroundColor: selectedColor, width: '100%', height: '100%' }} />
                       </Button>
                   </Popover>
                   <Dropdown menu={strokeWidthMenu} trigger={['click']}>
                       <Button style={{ width: 60, height: 20, display: 'flex', justifyContent: 'center', alignItems: 'center', paddingLeft: 5, paddingRight: 5 }}>
                           <LineWidthPreview strokeWidth={strokeWidth} top={0}  color="black"  />
                       </Button>
                   </Dropdown>
                   {/* <Tooltip title="Switch between Highlighter / Outline">
                       <Switch checked={isHighlighterMode} onChange={handleModeChange} checkedChildren="Highlighter" unCheckedChildren="Outline" />
                   </Tooltip> */}
                   {isHighlighterMode ? (
                       <div style={{ display: 'flex', alignItems: 'center' }}>
                           <span>Opacity:</span>
                           <Slider defaultValue={opacity * 100} onChange={handleOpacityChange} style={{ width: 100 }} />
                       </div>
                   ) : null}
                   <Tooltip title="Undo last highlight">
                       <Button icon={<UndoOutlined />} onClick={handleUndo} />
                   </Tooltip>
                   <Tooltip title="Redo last highlight">
                       <Button icon={<RedoOutlined />} onClick={handleRedo} />
                   </Tooltip>
                   <Tooltip title="Clear All Highlights">
                       <Button icon={<DeleteOutlined />} onClick={handleClearAll} />
                   </Tooltip>
                   <Tooltip title="Enable Move Mode">
                       <Switch checked={isMoveMode} onChange={handleMoveModeChange} checkedChildren="Move" unCheckedChildren="Move Off" />
                   </Tooltip>
                   <Tooltip title="Enable Resize Mode">
                       <Switch checked={isResizeMode} onChange={handleResizeModeChange} checkedChildren="Resize" unCheckedChildren="Resize Off" />
                   </Tooltip>
               </ControlsContainer>
           ) : null}
           <DefaultAudioGenerator handleCloseModal={handleCloseModal} resultRectangle={resultRectangle} handleUpdateAudio={handleUpdateAudio} handleUpdateVideo={handleUpdateVideo} handleUpdateDefinition={handleUpdateDefinition} pageId={pageId} bookId={bookId} imageUrl={imageUrl} setAudioModal={setAudioModal} setVideoModal={setVideoModal} setDefinitionModal={setDefinitionModal} openAudioModal={openAudioModal} openVideoModal={openVideoModal} openDefinitionModal={openDefinitionModal} audioUrl={audioUrl} videoUrl={videoUrl} openAllModal={openAllModal} handleClose={handleClose} />
       </Container>
        </>
       
    );
};

export default ImageHighlighterAdmin;
